import Repository from '@/repositories/repository'

const ContactUsRepository = {
  async getContactUsData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('contact-us', 'page', params)
  }
}

export default ContactUsRepository
